import { Link } from 'react-router-dom'

const admin = [
  {
    key: 'mainMenu1',
    label: <Link to='/administrator/annonces'>Annonces</Link>
  },
  {
    key: 'mainMenu2',
    label: <Link to='/administrator/compte'>Compte</Link>
  },
  {
    key: 'mainMenu3',
    label: <Link to='/administrator/photos'>Photos</Link>
  }
]

const provider = []

export const rootMenuLink = (role) => {
  switch (role) {
    case 'admin':
      return '/administrator/annonces'
    default:
      return '/'
  }
}

export const mainMenu = {
  admin,
  provider
}
